<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印客户条码"
      class="materialCodeModal"
      width="700px"
      top="5vh">
    <!--   36*15-->
    <div id="labelSettings">
      <el-form :inline="true" label-width="80px">
        <el-form-item label="订单备注">
          <textarea rows="8" v-model="printNote"/>
        </el-form-item>
        <el-form-item label="条码">
          <el-input v-model.trim="barCodeText" @input="codeChange"/>
        </el-form-item>
      </el-form>
    </div>
    <el-divider/>
    <div id="printMaterialBoxLabel8">
      <div style="margin:5px 5px 0px 5px;text-align: center;">
        <img style="width: 100%;height:20px;" :id="(() => 'barCode8_'+productInfo.pkid)()">
        <div style="font-size: 15px;font-weight: bold;margin-top: -2px;">{{barCodeText}}</div>
      </div>

    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import JsBarcode from "jsbarcode";
  // import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        titleName: "Tuning Reactor",
        logoVisible: true,
        printNote: "",
        productInfo: {},
        logoSrc: "",
        logoCeSrc: "",
        madeInChinaSrc: "",
        barCodeText: "",
        printOption: {
          id: "printMaterialBoxLabel8",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(productInfo) {
        this.dialogVisible = true;
        this.productInfo = productInfo;
        this.printNote = this.productInfo.salesOrderMaterialNote;

        this.barCodeText = "";
        if (this.barCodeText) {
          this.$nextTick(() => {
            document.getElementById("barCode8_" + this.productInfo.pkid).innerHTML = "";
            this.bindBarCode(this.barCodeText, this.productInfo.pkid);
          });
        }
      },
      bindBarCode(row, id) {
        let text = row;
        new JsBarcode(document.getElementById("barCode8_" + id), row, {
          text: text,
          fontSize: 14,
          width: 4,
          height: 8,
          margin: 0,
          displayValue: false,
        });
      },
      codeChange() {
        // this.$nextTick(() => {
        if (this.barCodeText) {
          document.getElementById("barCode8_" + this.productInfo.pkid).innerHTML = "";
          this.bindBarCode(this.barCodeText, this.productInfo.pkid);
        }
        // });
      },

      print() {
      },
    },
  };
</script>

<style lang="scss" scoped>
#printMaterialBoxLabel8 {
  width: 36mm;
  height: 15mm;
  margin: 0 auto;
  //margin-top: 1mm;
  page-break-before: always;
  //align-items: center;
}
</style>
